<template>
  <div class="news">
    <drug-guide title="新闻资讯" :headimg="newsHead" :enimg="enImg"></drug-guide>
    <div class="news-tab">
      <div class="news-tablist">
        <div :class="tabidx == index ? 'news-tabitem on' : 'news-tabitem'" v-for="(item, index) in tabList" :key="index" @click="getTab(index)">{{ item.name }}</div>
      </div>
    </div>
    <div class="newslist">
      <div class="newsitem" v-for="(item, index) in newsList" :key="index" @click="getDetail(item.id)">
        <div class="newsitem-img">
          <img :src="item.thumb" alt="">
        </div>
        <div class="newsitem-con">
          <div class="newsitem-title">{{ item.title }}</div>
          <div class="newsitem-desc">{{ item.bref }}</div>
          <div class="newsitem-dot">
            <div class="newsitem-time">
              <img :src="timeImg" alt="">
              <div>{{ item.ctime }}</div>
            </div>
            <div class="newsitem-more">
              <div>MORE</div>
              <img :src="rightImg" alt="">
            </div>
          </div>
        </div>
      </div>
      <el-pagination class="workpage" background layout="prev, pager, next" :total="total" prev-text="上一页" next-text="下一页" @current-change="currentChange"></el-pagination>
    </div>
    <drug-footer></drug-footer>
  </div>
</template>

<script>
import DrugFooter from "../../components/DrugFooter";
import DrugGuide from "../../components/DrugGuide";
import { getCate, getList } from "@/api/index";
export default {
  name: "News",
  components: {
    DrugFooter,
    DrugGuide
  },
  data() {
    return {
      newsHead: "static/images/news/news-head.png",
      enImg: "static/images/news/news-en.png",
      timeImg: "static/images/news/news-time.png",
      rightImg: "static/images/news/news-right.png",
      tabidx: 0,
      tabList: [],
      newsList: [],
      page: 1,
      total: 0
    }
  },
  computed: {
    pid: {
      get () {
        return this.$store.state.pid;
      }
    },
  },
  watch: {
    '$store.state.keyword'(val) {
      var activeVal = this.$store.state.activeVal;
      if(activeVal == 3) {
        getList(this.pid, this.tabList[this.tabidx].id, this.page, val).then((res) => {
          if(res.data.code == 1) {
            this.newsList = res.data.data.rows;
            this.total = res.data.data.total;
          }
        })
      }
    }
  },
  methods: {
    // 分页
    currentChange(index) {
      this.page = index;
      this.getNewsList(this.tabList[this.tabidx].id);
    },
    // 类型切换
    getTab(index) {
      this.tabidx = index;
      this.page = 1;
      this.getNewsList(this.tabList[index].id);
    },
    // 详情跳转
    getDetail(id) {
      this.$router.push({
        path: "/news/detail",
        query: { id }
      })
    },

    getCateList() {
      this.tabList = [];
      var id = this.pid ? this.pid : 2;
      getCate(id).then((res) => {
        if(res.data.code == 1) {
          var list = res.data.data;
          for(let i in list) {
            this.tabList.push(list[i]);
          }
          if(list.length > 0) {
            this.getNewsList(this.tabList[0].id);
          } else {
            this.getNewsList(null);
          }
        }
      })
    },

    // 获取列表数据
    getNewsList(cateId) {
      getList(this.pid ? this.pid : 2, cateId, this.page, "").then((res) => {
        if(res.data.code == 1) {
          this.newsList = res.data.data.rows;
          this.total = res.data.data.total;
        }
      })
    }
  },
  mounted() {
    this.$store.commit("getactive", 3);
    this.getCateList();
  },
}
</script>

<style lang="scss" scoped>
.news {
  .news-tab {
    width: 100%;
    height: 50px;
    background: #fff;
    .news-tablist {
      width: 80%;
      height: 100%;
      margin: auto;
      display: flex;
      align-items: center;
      cursor: pointer;
      .news-tabitem {
        height: 100%;
        line-height: 50px;
        padding: 0 32px;
        color: #7C828A;
        &.on {
          color: #fff;
          background: linear-gradient(270deg, #B1FAFF 0%, #4392EC 100%);
          font-family: "PingFang SC-Medium", "PingFang SC";
        }
      }
    }
  }
  .newslist {
    width: 80%;
    height: auto;
    overflow: hidden;
    margin: auto;
    .newsitem {
      padding: 28px 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #fff;
      margin-top: 20px;
      cursor: pointer;
      .newsitem-img {
        // width: 430px;
        height: 240px;
        img {
          // width: 100%;
          height: 100%;
          display: block;
        }
      }
      .newsitem-con {
        padding-right: 20px;
        width: 60%;
        height: 240px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .newsitem-title {
          width: 95%;
          height: 40px;
          line-height: 40px;
          font-size: 26px;
          font-family: "PingFang SC-Medium", "PingFang SC";
          font-weight: 500;
          color: #223037;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .newsitem-desc {
          width: 95%;
          font-weight: 400;
          color: #7C828A;
          line-height: 28px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3; /*最大行数*/
        }
        .newsitem-dot {
          width: 100%;
          height: 40px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .newsitem-time {
            display: flex;
            align-items: center;
            color: #4392EC;
            img {
              width: 16px;
              height: 16px;
              margin-right: 5px;
            }
          }
          .newsitem-more {
            width: 110px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #ddd;
            color: #7C828A;
            img {
              width: 16px;
              height: 15px;
              margin-left: 5px;
            }
          }
        }
      }
    }
    .workpage {
      width: 90%;
      margin: 40px auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

// 分页器样式
.news /deep/ .el-pagination.is-background {
  color: #909090;
  font-weight: 400;
}
.news /deep/ .el-pagination.is-background .el-pager li {
  width: 38px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  margin: 0 5px;
  font-size: 16px;
}
// 上一页/下一页
.news /deep/ .el-pagination.is-background button {
  height: 40px;
  padding: 0 10px;
}
.news /deep/ .el-pagination.is-background button span {
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/pages/news/news.vue